import { OvertimeComponent } from "../../components";

export default function OvertimeRegistrationDetailPage() {
  return <OvertimeComponent.OvertimeRegistrationDetail />;
}
